module.exports = __webpack_public_path__ + "components/flag/static/square/do-67c40ec2a2de69aa10c4e89c3e4208a6.svg";